import { useState } from 'react';

import { Radio, RadioGroup, FormControlLabel, TextField } from '@material-ui/core';

export default function ExistingLoan() {
  const [hasExistingLoan, setHasExistingLoan] = useState('no');

  return (
    <fieldset>
      <legend className="quoteform__heading">Do you have any existing loan?</legend>
      <div className="quoteform__input">
        <RadioGroup name="existing-loan" value={hasExistingLoan} onChange={({ target: { value } }) => setHasExistingLoan(value)}>
          <FormControlLabel value="yes" control={<Radio color="primary" />} label="Yes" />
          <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
        </RadioGroup>
      </div>
      {"yes" === hasExistingLoan && (
        <div className="quoteform__grid quoteform__grid--canWrap">
          <div className="quoteform__input quoteform__input--isRight">
            <TextField name="existing-loan-bank" fullWidth label="Bank/Financial Institution" variant="outlined" autoComplete="bank-off" />
          </div>
          <div className="quoteform__input quoteform__input--isRight quoteform__input--isLeft">
            <TextField name="existing-loan-account-number" fullWidth label="Account Number" variant="outlined" autoComplete="account-off" />
          </div>
          <div className="quoteform__input quoteform__input--isLeft">
            <TextField name="existing-loan-balance" fullWidth label="Loan Balance (Approx)" variant="outlined" autoComplete="balance-off" />
          </div>
        </div>
      )}
    </fieldset>
  )
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanApplication/components/ExistingLoan.js